import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verification-banner',
  standalone: true,
  imports: [RouterLink, TranslocoPipe],
  templateUrl: './verification-banner.component.html',
  styleUrl: './verification-banner.component.scss',
})
export class VerificationBannerComponent {
  private readonly authService = inject(AuthService);

  readonly show = this.authService.showVerificationBanner;
}
